import * as Yup from 'yup';
import i18n from '../config/lang';


const t = i18n.t;
export const ClientAddressSchema = Yup.object().shape({
    clientAddressTypeId: Yup.number().required(t("Error.this_field_is_required", "This field is required")),
    street: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    street2: Yup.string(),
    zipCode: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    city: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    state: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    countryId: Yup.number().required(t("Error.this_field_is_required", "This field is required"))
});

export const ClientTaxSchema = Yup.object().shape({
    rfc: Yup
        .string()
        .matches(/^([a-zA-Z&]{3,4})(\d{2})(\d{2})(\d{2})([0-9a-zA-Z]{3})$/i, t("Error.incorrect_rfc_format", "Incorrect RFC format"))
        .required(t("Error.this_field_is_required", "This field is required")),
    clientType: Yup.number().required(t("Error.this_field_is_required", "This field is required")),
    taxRegimeId: Yup.number().required(t("Error.this_field_is_required", "This field is required")),
    razonSocial: Yup.string().required(t("Error.this_field_is_required", "This field is required"))
});

export const AdditionalDriverSchema = Yup.object().shape({
    firstName: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    lastName: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    phone: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    dateOfBirth: Yup.date().required(t("Error.this_field_is_required", "This field is required")),
    state: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    countryId: Yup.number().required(t("Error.this_field_is_required", "This field is required")),
    licenseExpiration: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    licenseNumber: Yup.string().required(t("Error.this_field_is_required", "This field is required")),
    licenseFile: Yup.mixed().required(t("Error.this_field_is_required", "This field is required"))
});

export const ClientEmailSchema = Yup.object().shape({
    email: Yup.string().email(t("Error.invalid_email", "Invalid Email")).required(t("Error.this_field_is_required", "This field is required"))
});
